import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxGaugeModule } from 'ngx-gauge';

@Component({
  selector: 'app-user-story-details',
  standalone: true,
  imports: [NgxGaugeModule, CommonModule, MatTooltipModule],
  templateUrl: './user-story-details.component.html',
  styleUrl: './user-story-details.component.scss'
})
export class UserStoryDetailsComponent {

  @Input()
  data: any = [];

  gaugeType: any = "arch";
  gaugeLabel = "User\nstory coverage";
  gaugeAppendText = "%";
  progressText = "Great progress!"

  get gaugeTooltip(): string {
    return `User story coverage\n${this.data?.covered}(${this.data?.total_coverage}%)`;
  }

  get roundedCoverage(): number {
    return Math.round(this.data?.total_coverage ?? 0);
  }
}
